export default class TextMessage {
    constructor(Rest) {
        this.rest = Rest.rest;
    }

    getContent(id, contentId) {
        return this.rest.one('textMessage', id).one('content', contentId).get();
    };
};